import {
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import {
  awaitContent$default2jefvu0cvwa0w as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function transferFromDelegate($this) {
  updateConsumed($this);
  var appended = $this.r4l_1.y4g($this.q4l_1.r4j());
  $this.s4l_1 = add($this.s4l_1, appended);
}
function updateConsumed($this) {
  $this.t4l_1 = add($this.t4l_1, subtract($this.s4l_1, $this.r4l_1.q2()));
  $this.s4l_1 = $this.r4l_1.q2();
}
var CountedByteReadChannelClass;
function CountedByteReadChannel() {
  if (CountedByteReadChannelClass === VOID) {
    class $ {
      constructor(delegate) {
        this.q4l_1 = delegate;
        this.r4l_1 = new (Buffer())();
        this.s4l_1 = 0n;
        this.t4l_1 = 0n;
      }
      u4l() {
        updateConsumed(this);
        return this.t4l_1;
      }
      w4j() {
        return this.q4l_1.w4j();
      }
      y4j() {
        return this.r4l_1.q3y() && this.q4l_1.y4j();
      }
      r4j() {
        transferFromDelegate(this);
        return this.r4l_1;
      }
      *z4j(min, $completion) {
        if (this.r4j().q2() >= fromInt(min)) {
          return true;
        }
        if (yield* this.q4l_1.z4j(min, $completion)) {
          transferFromDelegate(this);
          return true;
        }
        return false;
      }
      j4k(cause) {
        this.q4l_1.j4k(cause);
        this.r4l_1.l6();
      }
    }
    protoOf($).f4k = awaitContent$default;
    initMetadataForClass($, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    CountedByteReadChannelClass = $;
  }
  return CountedByteReadChannelClass;
}
function counted(_this__u8e3s4) {
  return new (CountedByteReadChannel())(_this__u8e3s4);
}
//region block: exports
export {
  counted as counted3iniv3aql3f9n,
};
//endregion

//# sourceMappingURL=CountedByteReadChannel.mjs.map
